import QuickPicksBoardPage from '~/domains/contest/domains/quickPick/pages/board';

export default QuickPicksBoardPage;
